export const trilhasComNomeObra = ["IMO", "INFRA"];

export const permiteNomeObra = (trilha) =>
  trilhasComNomeObra.includes(String(trilha?.nome ?? "").trim().toUpperCase());

export const normalizeNomeObra = (nomeObra, permitido) => {
  const valor = typeof nomeObra === "string" ? nomeObra.trim() : "";
  return permitido && valor ? valor : null;
};
